import React from 'react';
import RevenueWeekWidget from './RevenueWeekWidget';
import NotificationsWidget from './NotificationsWidget';
import IncomingDocumentsWidget from './IncomingDocumentsWidget';
import RecentDocumentsWidget from './RecentDocumentsWidget';
import DocumentStatusesWidget from './DocumentStatusesWidget';
import AttentionDocumentsWidget from './AttentionDocumentsWidget';
import PromotionsWidget from './PromotionsWidget';
import ReportTodayWidget from './ReportTodayWidget';
import NetworkRevenueWidget from './NetworkRevenueWidget';
import ReceivingDocumentsWidget from './ReceivingDocumentsWidget';
import QuickLinksWidget from './QuickLinksWidget';
import ReportSubmissionWidget from './ReportSubmissionWidget';
import ExpiryJournalWidget from './ExpiryJournalWidget';
import ProblemDocumentsWidget from './ProblemDocumentsWidget';

export interface WidgetDefinition {
  id: string;
  /** Право, открывающее виджет (проверка строго через hasPerm) */
  perm: string;
  /** В каких интерфейсах виджет доступен (часть виджетов - только админка, часть - только кабинет аптеки, часть - общие) */
  interfaces: Array<'admin' | 'dashboard'>;
  /**
   * Место в макете: левая (широкая, 2/3) или правая (узкая, 1/3) колонка первого экрана,
   * либо нижний ряд «bottom» - две равные колонки под всем верхним блоком (страница прокручивается вниз).
   */
  column: 'left' | 'right' | 'bottom';
  /**
   * Высота в колонке (для left/right):
   *  - число - занимает оставшееся место пропорционально (внутри скроллится);
   *  - 'auto' - строго по содержимому (короткий блок);
   *  - 'fit' - по содержимому, но не выше maxHeight px (дальше скролл внутри): при одной строке блок не раздувается,
   *    при большом списке не вытесняет соседей.
   * Для bottom не используется.
   */
  grow: number | 'auto' | 'fit';
  /** Для 'fit': потолок высоты блока в px (выше - скролл внутри), по умолчанию 300 */
  maxHeight?: number;
  component: React.ComponentType;
}

/**
 * Каталог виджетов «Главной» по макету: слева выручка + входящие + последние документы,
 * справа уведомления + статусы, внизу в две колонки - документы, требующие внимания, и акции.
 * Порядок = порядок вывода внутри колонки/ряда.
 * Новый виджет: компонент + право в миграции + скоупы (home.scopes.ts) + подгруппа/якорь (subgroupsConfig.ts) + запись здесь.
 */
export const HOME_WIDGETS: WidgetDefinition[] = [
  { id: 'revenue-week', perm: 'home.revenue.view', interfaces: ['dashboard'], column: 'left', grow: 'auto', component: RevenueWeekWidget },
  { id: 'report-today', perm: 'home.report_today.view', interfaces: ['dashboard'], column: 'left', grow: 'auto', component: ReportTodayWidget },
  { id: 'network-revenue', perm: 'home.network_revenue.view', interfaces: ['admin'], column: 'left', grow: 'auto', component: NetworkRevenueWidget },
  { id: 'incoming-documents', perm: 'home.documents.incoming.view', interfaces: ['admin', 'dashboard'], column: 'left', grow: 'fit', component: IncomingDocumentsWidget },
  { id: 'recent-documents', perm: 'home.documents.recent.view', interfaces: ['admin', 'dashboard'], column: 'left', grow: 'fit', maxHeight: 280, component: RecentDocumentsWidget },
  { id: 'notifications', perm: 'home.notifications.view', interfaces: ['admin', 'dashboard'], column: 'right', grow: 'auto', component: NotificationsWidget },
  { id: 'receiving-documents', perm: 'home.documents.receiving.view', interfaces: ['admin', 'dashboard'], column: 'right', grow: 'auto', component: ReceivingDocumentsWidget },
  { id: 'document-statuses', perm: 'home.documents.statuses.view', interfaces: ['admin', 'dashboard'], column: 'right', grow: 1, component: DocumentStatusesWidget },
  { id: 'quick-links', perm: 'home.quick_links.view', interfaces: ['admin'], column: 'bottom', grow: 1, component: QuickLinksWidget },
  { id: 'report-submission', perm: 'home.reports.submission.view', interfaces: ['admin'], column: 'bottom', grow: 1, component: ReportSubmissionWidget },
  { id: 'expiry-journal', perm: 'home.journal.expiry.view', interfaces: ['admin', 'dashboard'], column: 'bottom', grow: 1, component: ExpiryJournalWidget },
  { id: 'problem-documents', perm: 'home.documents.problem.view', interfaces: ['admin', 'dashboard'], column: 'bottom', grow: 1, component: ProblemDocumentsWidget },
  { id: 'attention-documents', perm: 'home.documents.attention.view', interfaces: ['admin', 'dashboard'], column: 'bottom', grow: 1, component: AttentionDocumentsWidget },
  { id: 'promotions', perm: 'home.promotions.view', interfaces: ['admin', 'dashboard'], column: 'bottom', grow: 1, component: PromotionsWidget }
];
